// extracted by mini-css-extract-plugin
export default {"product_card":"ProductCard_product_card__8iGFH","product_card-images":"ProductCard_product_card-images__hzgcP"};